
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.607 8h12.787L19 9H5l.607-1zm10.359-4H8.035l-.607 1h9.145l-.607-1zM6.821 6l-.607 1h11.573l-.607-1H6.821zM24 9.986V23H0V9.986L5.477 1h13.069L24 9.986zM16 14a1 1 0 00-1-1H9a1 1 0 100 2h6a1 1 0 001-1zm5.669-4L17.42 3H6.6l-4.266 7h19.335z"}})])
          )
        }
      }
    